import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ProductService } from 'src/app/services/product.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Constant } from 'src/app/constant/constant';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'calsoft-product-link',
  templateUrl: './product-link.component.html',
  styleUrls: ['./product-link.component.scss']
})
export class ProductLinkComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  productId: any;
  setId: any;
  superLinkListValue: any = [];
  sortParam: any = 'entityId' + "," + Constant.Dsc;
  columns: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  elements: any;
  linkTypeId: any;
  productLinkList: any = [];
  title: any;
  oldList: any=[];
  gridList: any=[];
  constructor(
    public formBuilder: UntypedFormBuilder,
    private productService: ProductService,
    private dialogRef: MatDialogRef<ProductLinkComponent>,
    private snackBar: MatSnackBar,
   
    @Inject(MAT_DIALOG_DATA) public  data:any, private router: Router) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
      dialogRef.disableClose = true;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });  
   
 
  
  }

  ngOnInit(): void {


    this.productId = this.data.productId
    this.setId = this.data.setId
  


    this.superLinkListValue = this.data.superLinkList;
    this.linkTypeId = this.data.linkTypeId;
    this.title = this.data.title;
    this.getLinkedProducts()
  }

  close() {
    this.productLinkList=[]
    this.superLinkListValue=this.oldList
    this.dialogRef.close({ event: 'add', data: this.superLinkListValue,productLinkList:this.productLinkList,linkTypeId:this.linkTypeId})
  }


  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  spinner: boolean = false;
  productList: any = [];
  newlyAddedList:any=[];
  pageList: any;
  pageSizeValue: any;
  filterActive: boolean = false;
  search: any;
  getLinkedProducts() {

    this.spinner = true;

    this.oldList=this.data.oldList
    this.gridList=this.oldList
  
    this.productService.productNotLinked(this.gridList, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
      
        this.elements = res['data']['numberOfElements'];
        this.productList = res['data']['content'];

        this.pageList = res['data']['totalElements'];

        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      }
    )
  }

  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }

 
 sortData(event) {
    if (event.active != 'actions') {
    this.page = Constant.PAGE;
    this.size = Constant.SIZE;
    this.sortParam = event.active;
    if (event.direction == 'asc') {
      this.sortParam = this.sortParam + "," + Constant.Asc;
    } else if (event.direction == 'desc') {
      this.sortParam = this.sortParam + "," + Constant.Dsc;
    }
    this.DetectingRequestType();
   }
  }

  DetectingRequestType() {
    if (!this.filterActive) {

      this.superLinkListValue=this.oldList
      this.getLinkedProducts();
    }
    else {
      this.filterOption(this.search);
    }
  }

  filterOption(event) {
    this.filterActive = true;
    this.search = event;
    this.spinner = true;
    let object={
      searchterm:this.search,
      productIds:this.superLinkListValue
    }

    if(this.superLinkListValue.length==0){
      this.superLinkListValue.push(0)
    }
    this.productService.productNotLinkedSearch(object, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.productList = res['data']['content'];
        this.elements = res['data']['numberOfElements'];
        this.pageList = res['data']['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })

  }

  onFilterChange(value) {
    if (value == '') {
      
      this.getLinkedProducts();
      this.search = '';
    }
    else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
     
      let searchTerm = "name:" + '*' + value.trim() + '*'
      + "' OR sku:" + '*' + value.trim() + '*' + "' "
      this.filterOption(searchTerm)
    }
  }

  onFilterChangeColumn(i) {
    if (i == undefined) {
      this.productLinkList=[]
      this.newlyAddedList=[];
      this.filterActive=false
      this.getLinkedProducts();
    } else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.filterOption(i)
    }
  }

  onChange(productId, isChecked: boolean,product:any) {

    

    if (isChecked) {

      let productLinkObject = {
        linkId: 0,
        productId: this.productId,
        linkedProductId: productId,
        linkTypeId: this.linkTypeId,
        operationType: "New",
        name:product.name,
        sku:product.sku,
        price:product.price
      }
      this.newlyAddedList.push(productId);

      this.productLinkList.push(productLinkObject)
    } else {

      let productLinkIndex = this.productLinkList.findIndex(x => x.linkedProductId == productId)

      this.productLinkList.splice(productLinkIndex, 1);

      let superLinkListValueIndex = this.newlyAddedList.findIndex(x => x == productId)
      this.newlyAddedList.splice(superLinkListValueIndex, 1);



    }



  }
  
  addSelectedProduct() {
    if(this.productLinkList.length>0){

      this.superLinkListValue = [ ...this.superLinkListValue, ...this.newlyAddedList];
      this.dialogRef.close({ event: 'add', data: this.superLinkListValue,productLinkList:this.productLinkList,linkTypeId:this.linkTypeId})
    }else{
      this.snackBar.open("Please Select Atleast one Product", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    }
   
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
